import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 20 14", stroke: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 7H13M1 1H19M1 13H19", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMenu;
